(ns app.front.view.permit.renewal
  (:require [app.front.entity-edit :as ee]
            [app.front.process :as process]
            [app.front.process.save-tracking :as save-tracking]
            [app.front.view.application-wizard.subs :as application-wizard-subs]
            [core.front.feature-flags :as ff]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-db ::check-renewal-availability.success
  (fn [db [_ workspace-id request-id _ response]]
    (let [result (get-in db [::renewal-number-availability workspace-id])]
      (if (= request-id (:request-id result))
        (assoc-in db [::renewal-number-availability workspace-id :response] response)
        db))))

(rf/reg-sub ::renewal-number-available
  (fn [db [_ workspace-id]]
    (get-in db [::renewal-number-availability workspace-id :response])))

(defn year-only-renewal-numbering-enabled? [renewal-workspace? workspace feature-enabled?]
  (and renewal-workspace?
       feature-enabled?
       (-> workspace
           :domain/authority-group
           :group/municipal-case-id-year-only-on-renewal?)))

(defn- invalidate-availability [db workspace-id]
  (assoc-in db [::renewal-number-availability workspace-id] {:request-id (random-uuid)}))

(rf/reg-event-fx ::check-renewal-availability
  (fn [{:keys [db]} [_ workspace-id]]
    (let [db            (invalidate-availability db workspace-id)
          request-id    (get-in db [::renewal-number-availability workspace-id :request-id])
          saving-draft? (contains? (save-tracking/processing-signal-ids db workspace-id)
                                   :process.signal/update-verdict-draft)]
      (cond-> {:db db}
        (not saving-draft?)
        (assoc :comm/command {:command    :licence/check-number-occupied
                              :method     :post
                              :data       {:workspace-id workspace-id}
                              :on-success [::check-renewal-availability.success
                                           workspace-id
                                           request-id]})))))

(rf/reg-event-fx ::update-renewal-valid-to
  (fn [{:keys [db]} [_ application-id workspace-id section-id new-value]]
    {:db (-> db
             (ee/set-value section-id :verdict.section/content new-value)
             (invalidate-availability workspace-id))
     :dispatch-debounce
     [{:id      (str "section-changed-" section-id)
       :timeout 500
       :action  :dispatch
       :event   [::process/signal
                 application-id
                 [:process.signal/update-verdict-draft
                  {:verdict.section/content new-value
                   :section-id              section-id}]
                 {:on-success [::check-renewal-availability workspace-id]
                  :on-done    [::ee/save-done section-id :verdict.section/content new-value]}]}]}))

(rf/reg-sub ::year-only-renewal-numbering?
  :<- [::application-wizard-subs/renewal-workspace?]
  :<- [::application-wizard-subs/workspace]
  :<- [::ff/enabled? :feature-flag.id/municipal-case-id-year-only-on-renewal?]
  (fn [[renewal-workspace? workspace feature-enabled?] _]
    (year-only-renewal-numbering-enabled? renewal-workspace? workspace feature-enabled?)))
